const errorMessages = {
	REQUIRED_FIELD: 'Campo obrigatório',
	INVALID_EMAIL: 'E-mail inválido',
	INVALID_BIRTHDAY: 'Insira uma data válida',
};

export default errorMessages;
